<template>
  <div>
    <vs-input class="w-full mb-8" v-model="dataLocal.min" label-placeholder="最低下注金额 (元)" />
    <vs-input class="w-full mb-8" v-model="dataLocal.default" label-placeholder="默认反水比例 (%)" />
    <vs-input class="w-full" v-model="dataLocal.time" label-placeholder="每天系统自动反水的时间" />
  </div>
</template>

<script>

export default {
  props: {
    data: {
      type: String,
      default: '{}'
    }
  },
  data() {
    return {
      dataLocal: {}
    }
  },
  methods: {
    getParam() {
      return JSON.stringify(this.dataLocal)
    }
  },
  mounted() {
    this.dataLocal = JSON.parse(this.data)
  }
}
</script>
